import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=472c5959"
import script from "./userAvatar.vue?vue&type=script&lang=js"
export * from "./userAvatar.vue?vue&type=script&lang=js"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=472c5959&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports